import axiosInstance from "utils/axios";

const getInventoryCars = async (filter) => {
  try {
    const response = await axiosInstance.get("/car-report/get-car-inventery", {
      params: filter,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching inventory car list:", error);
    throw error;
  }
};

const getAllOrderAccount = async () => {
  try {
    const response = await axiosInstance.get("/car-report/getAllOrderAccount");
    return response.data;
  } catch (error) {
    console.error("Error fetching all order accounts:", error);
    throw error;
  }
};

const getCarInterest = async (filter) => {
  try {
    const response = await axiosInstance.get("/car-report/get-car-interest", {
      params: filter,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching car interest list:", error);
    throw error;
  }
};

const CarReportService = {
  getInventoryCars,
  getAllOrderAccount,
  getCarInterest,
};
export default CarReportService;
